<template>
  <div>
    <label :for="id" class="mb-2"><b>{{ label }}</b></label>
    <div class="flex items-start justify-between">
      <vs-textarea
        rows="5"
        :id="id"
        :disabled="lock"
        :class="isEditedClass"
        :value="value"
        :placeholder="placeholder"
        @input="$emit('input', $event)"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        ref="textarea"
      />
      <vs-button
        class="ml-6"
        type="flat"
        icon-pack="feather"
        :icon="lock ? 'icon-lock' : 'icon-unlock'"
        size="large"
        @click="handleClick" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    isEditedClass: {
      type: String
    }
  },
  data () {
    return {
      id: null,
      lock: true
    }
  },
  created () {
    this.id = this._uid
  },
  methods: {
    handleClick () {
      this.lock = !this.lock
    }
  }
}
</script>
